export const rules={
  title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
  date: [{ required: true, message: '请选择时间', trigger: 'change' }],
  picture: [{ required: true, message: '请选择图片', trigger: ['blur','change'] }],
  successCriteria: [{ required: true, message: '请选择', trigger: 'change' }],
  activityRules: [{ required: true, message: '请输入活动规则', trigger: 'blur' }],
  enabled: [{ required: true, message: '请选择状态', trigger: 'change' }]
}
